module.exports = __webpack_public_path__ + "static/media/bar-chart.87ac793e.svg";